import uniq from "lodash/uniq";

export const hasDuplicates = (
  array = [],
  whiteListPattern = [/^null$/i, /^ignore$/i, /^ignore[^a-zA-Z0-9]*field$/i]
) => {
  const preparedArray = array.filter(
    value => value && !whiteListPattern.some(pattern => pattern.test(value))
  );

  return preparedArray.length !== uniq(preparedArray).length;
};
